import styled from 'styled-components';

export const StyledPrivateData = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-top: 12px;
`;

export const StyledBlurredItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledBlurredPrivateData = styled(StyledPrivateData)`
  flex-direction: row;
  justify-content: space-between;
`;
